import { isUsageFilter, type UsageFilter } from './isUsageFilter';

/**
  Retrieves the number of filters in a filter group exclusionary of boolean usage filters
  denoting a nested filter group and undefined filters.
  
  @param parentFilter - the boolean usage filter that encompasses all filters for a
  filter group

  @returns {number} - the number of filters in the provided filter group
*/
export function getNumberOfFiltersInGroup(parentFilter: UsageFilter): number {
  const filters = parentFilter.value;
  let numberOfFilters = 0;

  for (const filter of filters) {
    if (isUsageFilter(filter)) {
      numberOfFilters += getNumberOfFiltersInGroup(filter);
    } else if (filter.fieldId) {
      numberOfFilters++;
    }
  }

  return numberOfFilters;
}
